import "material-design-icons-iconfont/dist/material-design-icons.css";
import "@mdi/font/css/materialdesignicons.css";
import "@fortawesome/fontawesome-free/css/all.css";
import Vue from "vue";
import Vuetify from "vuetify/lib";

Vue.use(Vuetify);

// Vuetify.config.silent = true; // Vuetify관련 콘솔로그 표시 제어 (true: 로그 제한함 ,default :flase)
const RX_ICONS_MDI = {
  /** 버튼 아이콘 START */
  // btn_add: "mdi-plus", // 신규추가 버튼
  ld_kakao_outlined: "M12,1C5.4,1,0.1,5.2,0.1,10.3c0,3.2,2.1,6.2,5.4,7.9L5,21.3l-0.1,0.5c-0.2,0.9,0.8,1.6,1.6,1l0.4-0.3l4.1-2.9c0.4,0,0.7,0,1,0c6.5,0,11.9-4.2,11.9-9.4C23.8,5.2,18.5,1,12,1z M12,18.5c-0.5,0-0.9,0-1.3-0.1l-4.5,3.1l0.8-4c-3.3-1.4-5.6-4.1-5.6-7.2c0-4.5,4.8-8.2,10.6-8.2s10.6,3.6,10.6,8.2C22.6,14.8,17.9,18.5,12,18.5z M15.1,12.8h-1.7V8.6c0-0.3-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6v4.2v0.5c0,0.3,0.3,0.6,0.6,0.6h2.2c0.3,0,0.6-0.3,0.6-0.6C15.7,13,15.4,12.8,15.1,12.8z M11.7,13.1l-0.1-0.4L10,8.6c-0.3-0.8-1.4-0.8-1.7,0l-1.6,4.1h0l-0.1,0.4l0,0c0,0.1,0,0.1,0,0.2c0,0.4,0.3,0.6,0.6,0.6c0.3,0,0.5-0.2,0.5-0.4l0,0L8,12.7h2.3l0.3,0.8l0,0c0.1,0.2,0.3,0.4,0.5,0.4c0.4,0,0.6-0.3,0.6-0.6C11.8,13.3,11.8,13.2,11.7,13.1L11.7,13.1z M8.6,11.6L9.1,10l0.1-0.2l0.4,1.1l0.3,0.7H8.6z M7.6,8.5C7.6,8.2,7.4,8,7.1,8H3.5C3.2,8,3,8.2,3,8.5s0.2,0.5,0.5,0.5h1.2v4.3h0c0,0.2,0.1,0.4,0.3,0.5c0.3,0.2,0.6,0.1,0.8-0.2c0.1-0.1,0.1-0.2,0.1-0.3h0V9.1h1.2C7.4,9.1,7.6,8.8,7.6,8.5z M18.5,10.7L20.2,9c0.2-0.2,0.2-0.6,0-0.8h0C20,8,19.6,8,19.4,8.2l-2.1,2.1V8.6C17.3,8.3,17,8,16.7,8c-0.3,0-0.6,0.3-0.6,0.6v4.7c0,0.3,0.3,0.6,0.6,0.6c0.3,0,0.6-0.3,0.6-0.6v-1.4c0,0,0,0,0,0l0.4-0.4l1.6,2.1c0.3,0.3,0.6,0.3,0.8,0.1c0.3-0.2,0.3-0.6,0.1-0.8L18.5,10.7z", // 카카오(outlined)
  fld_kakao: "M22.5 11.185C22.5 6.664 17.799 3 12 3C6.201 3 1.5 6.665 1.5 11.185C1.5 14.061 3.405 16.591 6.285 18.051L5.393 21.729C5.187 22.378 5.364 22.407 5.865 22.142L10.273 19.259C10.8457 19.3326 11.4226 19.3693 12 19.369C17.799 19.369 22.5 15.705 22.5 11.185Z", // 카카오(filled)

  fld_login_id: "person", // 로그인 아이디
  fld_pword: "lock", // 패스워드
};

 const opts = {
    icons: {
        iconfont: 'mdi' || 'md',
        values: addVuerify(),
    },
}

function addVuerify() {
  // 1. plugins 폴더 내의 vuetify.js 파일 모두 가져옴
  const js = require.context("@", true, /plugins\/vuetify.js$/i);

  // 2. vuetify
  let resultVuetify = Object.assign({}, RX_ICONS_MDI);

  // 3. RX_ICONS_MDI(/redworks/plugins/vuetify.js 제외)에 다른 vuetify 아이콘 정보 담기
  js.keys().forEach((key) => {
    const split = key.split("/");
    if (split && split.length > 2 && split[1] != "redworks") {
      const addVuetify = js(key).default;
      resultVuetify = Object.assign(resultVuetify, addVuetify);
    }
  });
  return resultVuetify;
}


export default new Vuetify(opts);